import React from 'react';
import Home01 from '../components/Home01.js';
import Home02 from '../components/Home02.js';
import Home03 from '../components/Home03.js';
import Home04 from '../components/Home04.js';
import Footer from '../components/Footer.js';
import '../css/Home.css';

const Home = () => {
    return (
        <div>
            <div className='background-element image'/>
            <Home01/>
            <Home02/>
            <Home03/>
            <Home04/>
            <Footer/>
        </div>
    );
};

export default Home;
